export default __webpack_public_path__ + "static/media/13 3D (2-4).afe87b16.jpg";